import React from "react";
import PropTypes from "prop-types";
import Icon from "../../elements/icon";
import "./style.scss";

const GearShoppingPerks = ({ perks = [] }) => {
  return (
    <div className="gear-shopping-perks grid">
      <div
        className="content"
        style={{
          justifyContent: perks.length > 2 ? "space-between" : "space-around"
        }}
      >
        {perks.map(({ fields }) => (
          <div className="perk" key={fields.text.value}>
            <Icon icon={fields.icon.value} />
            <div className="text">{fields.text.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

GearShoppingPerks.propTypes = {
  perks: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        icon: PropTypes.object,
        text: PropTypes.object
      })
    })
  )
};

export default GearShoppingPerks;
